import React from 'react';
import RiskItem from '../changeRequest/RiskItems';
import { TriangleAlert } from 'lucide-react';

const AssociatedRisks = ({  risks, isLoading }) => {
  const hasOpenRisks = risks && risks.length > 0 ? risks.some(risk => risk.status !== 5) : false;
  return (
      !isLoading && risks && risks.length > 0 &&
      (
        <div className='risks-overview-container' style={hasOpenRisks ?{ borderColor: '#d1424f' }:{}}>
        <div className="d-flex align-items-center mb-3 risks-overview-header-container">
          <div className='mx-2'>{hasOpenRisks && <TriangleAlert size={16} color="#d1424f" /> }</div>
          <p className="text-md-600 all-risks" title="This scope may include specific risks that could impact project objectives. Please review the associated risks to ensure appropriate mitigation measures are in place.">
            Associated Risks
          </p>
          <span className="badge-label">{risks.length}</span>
        </div>
        {risks.map((risk, index) => (
          <RiskItem key={index} item={risk} />
        ))}
      </div>
      )
  );
};

export default AssociatedRisks;